import { questionOptionsModalSliceDispatch } from "../../Constants/ReduxConstants";

//Every reducer needs initial state.
const initialState = {
    open: false,
    allOptions: []
}

export default function questionOptionsModalSlice(state = initialState, action) {
    switch (action.type) {
        case questionOptionsModalSliceDispatch.setOpen: {
            return {
                ...state,
                open: action.payload
            }
        }
        case questionOptionsModalSliceDispatch.setValueToAdd: {
            return {
                ...state,
                valueToAdd: action.payload
            }
        }
        case questionOptionsModalSliceDispatch.setOptionToAdd: {
            return {
                ...state,
                optionToAdd: action.payload
            }
        }
        case questionOptionsModalSliceDispatch.setAllOptions: {
            return {
                ...state,
                allOptions: action.payload
            }
        }
        default:
            return state
    }
}
